<app-profile-settings-tab-display
  [profiles]="tankProfiles$ | async"
  [appliedProfile]="currentTankProfile$ | async"
  [selectedProfile]="currentEditingTankProfile"
  [config]="tankProfileConfig"
  [loading]="loading"
  [displayPreview]="editProfileIsCurrentProfile"
  (editProfileClicked)="onEditingProfile($event)"
  (createProfileClicked)="onCreateNewProfile()"
  (applyProfileClicked)="onApplyProfile($event)"
  (copyProfileClicked)="onCopyProfile($event)"
  (deleteProfileClicked)="onDeleteProfile($event)"
  (cancelProfileClicked)="tankProfileSettings.cancel()"
  (saveProfileClicked)="tankProfileSettings.save()"
  (resetProfileClicked)="tankProfileSettings.reset()"
  (previewProfileClicked)="tankProfileSettings.preview()"
  [disableSave]="tankProfileSettings.disableSave"
  [formGroup]="currentTankProfileFormGroup"
>
  <div header-container>
    <h3 *ngIf="!editingName" class="m-0 flex items-center gap-1 text-xl font-semibold">
      {{ displayedProfileName }}
      <button
        mat-icon-button
        type="button"
        (click)="onEditProfileNameClicked()"
        *ngIf="!currentEditingTankProfile?.isReadOnly"
        [attr.aria-label]="'TankProfile.RenameProfile' | translate"
      >
        <mat-icon>edit</mat-icon>
      </button>
    </h3>
    <!-- One line, error included: the header row has a fixed height, so nothing may wrap below. -->
    <div *ngIf="editingName" class="flex items-center gap-1">
      <mat-form-field
        appearance="outline"
        class="tl-labelless-field tl-labelless-field--flush min-w-0 max-w-md flex-1"
        [formGroup]="currentTankProfileFormGroup"
      >
        <input
          #profileNameInput
          matInput
          type="text"
          formControlName="tankProfileName"
          maxlength="100"
          [attr.aria-label]="'TankProfiles.TankProfileName' | translate"
          (keydown.enter)="onConfirmProfileNameClicked($event)"
          (keydown.escape)="onCancelProfileNameClicked($event)"
        />
      </mat-form-field>
      <button
        mat-icon-button
        type="button"
        color="primary"
        [disabled]="!canConfirmProfileName"
        (click)="onConfirmProfileNameClicked()"
        [matTooltip]="'TankProfile.ConfirmRename' | translate"
        [attr.aria-label]="'TankProfile.ConfirmRename' | translate"
      >
        <mat-icon>check</mat-icon>
      </button>
      <button
        mat-icon-button
        type="button"
        (click)="onCancelProfileNameClicked()"
        [matTooltip]="'TankProfile.CancelRename' | translate"
        [attr.aria-label]="'TankProfile.CancelRename' | translate"
      >
        <mat-icon>close</mat-icon>
      </button>
      <span
        *ngIf="getTankNameErrorText() as error"
        class="min-w-0 truncate text-xs text-status-red"
        role="alert"
        [matTooltip]="error"
        >{{ error }}</span
      >
    </div>
  </div>

  <div edit-container class="h-full">
    <tank-profile-settings
      #tankProfileSettings
      [currentTankProfile$]="currentEditingTankProfile$"
      (previewProfileClicked)="onPreviewProfileClicked()"
      (tankProfileSaved)="onTankProfileSaved($event)"
    ></tank-profile-settings>
  </div>

  <div filters-container class="flex h-full w-full flex-col items-center justify-center">
    <span class="whitespace-normal text-center">{{ 'TankProfile.NoTankProfileSelectedToEdit' | translate }}</span>
  </div>

  <div no-profiles-container class="flex h-full w-full flex-col items-center justify-center">
    <span class="whitespace-normal text-center">{{ 'TankProfile.NoTankProfiles' | translate }}</span>
  </div>
</app-profile-settings-tab-display>
